var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 9.669c0-1.06.877-1.919 1.897-1.919h43.54c1.044 0 1.896.847 1.896 1.919v33.829c0 1.06-.877 1.919-1.896 1.919H7.23a1.903 1.903 0 0 1-1.897-1.92V9.67z",
    fill: "#405EDC",
    stroke: "#405EDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.385 14.104H17.88l-2.14.574v2.264l1.459-.39v4.844h-1.823v2.188h5.833v-2.188h-1.823v-7.292zm6.198.73h16.042v2.916H25.583v-2.916zm0 10.208h16.042v2.917H25.583v-2.917zm0 10.208h16.042v2.917H25.583V35.25zm-10.39-3.463a3.099 3.099 0 1 1 5.56 1.883l-.008.01-1.993 2.3h2.456v2.187h-5.833v-1.635l3.604-4.147a.912.912 0 1 0-1.596-.68l-.018.446h-2.173v-.364z",
    fill: "#E5EAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 50h-31a1.5 1.5 0 0 0 0 3h31a1.5 1.5 0 0 0 0-3z",
    fill: "#405EDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIcon);
export default __webpack_public_path__ + "static/media/computerIcon.8a66ebd5886059494969c77aaa3ae37b.svg";
export { ForwardRef as ReactComponent };